module.exports = __webpack_public_path__ + "img/astroslogo.b13c1d7b.png";